import { getRgObjectsOfType as r, RG_TYPE as s } from "@project-rouge/rg-core";
import { getLevelGIA as g } from "../level-metrics/index20.js";
const d = (l) => {
  let t = 0;
  const n = r(l, s.Building);
  for (const o of n) {
    const i = new Set(o.data.levels.map((e) => e.levelIndex));
    for (const e of i)
      t += g(o, e);
  }
  return t;
};
export {
  d as getGIA
};
//# sourceMappingURL=index26.js.map
